import React, { useMemo } from 'react'
import { detailedDiff } from 'deep-object-diff'
import Loading from '../../../../packages/kiti/components/helpers/Loading'
import ComparePanel from '../ComparePanel'

const AuditUpdate = ({ data }) => {
  const comparisonResult = useMemo(() => {
    const result = detailedDiff(data.before, data.after)

    return { ...result.added, ...result.updated, ...result.deleted }
  }, [data.after, data.before])

  if (!comparisonResult) return <Loading />

  const keys = Object.keys(comparisonResult)

  return (
    <>
      {keys.map(key => {
        if (key === 'documents') return false
        if (key === 'fieldValues') return false
        if (key === 'events') return false
        return <ComparePanel key={key} field={key} before={data.before} after={data.after} />
      })}
      {keys.includes('fieldValues') && (
        <ComparePanel key={'fieldValues'} field={'fieldValues'} before={data.before} after={data.after} />
      )}
      {keys.includes('documents') && (
        <ComparePanel key={'documents'} field={'documents'} before={data.before} after={data.after} />
      )}
      {keys.includes('events') && (
        <ComparePanel key={'events'} field={'events'} before={data.before} after={data.after} />
      )}
    </>
  )
}

export default AuditUpdate
